var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99444 0.578807L6.08807 0.584225C5.84136 0.584225 5.63755 0.788034 5.63219 1.04011L5.63213 5.58822L0.998263 5.58822C0.751439 5.58822 0.54763 5.79203 0.542374 6.04411V6.95589C0.54232 7.20266 0.746129 7.40647 0.998263 7.41178L5.62151 7.41178L5.63224 11.9599C5.63224 12.2067 5.83605 12.4105 6.08813 12.4158L6.99991 12.4158C7.24662 12.4158 7.45043 12.212 7.4558 11.9599L7.45574 7.41183L12.0039 7.41183C12.2506 7.41183 12.4544 7.20802 12.4598 6.95594L12.4598 6.04416C12.4598 5.79745 12.256 5.59364 12.0039 5.58828L7.45038 5.59364L7.45043 1.04553C7.45032 0.78798 7.24652 0.584171 6.99444 0.578807Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.81b5268c462d3e3cd85cd0c477095b71.svg";
export { ForwardRef as ReactComponent };